import {
  get,
  post
} from './http'
export default {
  checkIsVip(realname, cardno) {
    return post('User/CheckIsVip', {
      name: realname,
      idcard: cardno
    });
  },
  getUserData(openid) {
    return get('user/getUserData', {
      openid: openid
    });
  },
  updateUserData(userData) {
    return post('User/updateUserData', userData);
  },
  wechatLogin(code) {
    return get('User/Login', {
      code: code
    });
  },
  weixinLogin(code, type) {
    return get('User/LoginWeixin', {
      code: code,
      type: type
    });
  },
  getWxJsApiParams(url, merid) {
    return get('User/getWxJsApiParams', {
      url: url,
      merid: merid
    })
  },

	getToken(name,password){
	  return post('manager/ManagerInit/LoginBackground', {
	  	uid:name,
	  	pwd:password,
	  });
	},

  QueryCardList(){
    return get('UserOrder/QueryCardList', {
    	id:'',
    });
  },
  
  PutCard(cardid,openid,rid){
    return post('Promotion/PutCard', {
    	cardid:cardid,
      openid:openid,
      rid:rid,
    });
  },
  
  GetCardList(openid){
    return get('Promotion/GetCardListByOpenId', {
      OpenId:openid,
    });
  },
  
  getUserData(openid){
    return get('user/getUserData', {
      OpenId:openid,
    });
  },
  

}



// WEBPACK FOOTER //
// ./src/request/userApi.js